import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Divider,
    Chip,
    Stack,
    Box,
    Paper,
    useTheme,
  } from "@mui/material";
  import { format } from "date-fns";
  import AccessTimeIcon from "@mui/icons-material/AccessTime";
  import PersonIcon from "@mui/icons-material/Person";
  import DescriptionIcon from "@mui/icons-material/Description";
  import EventIcon from "@mui/icons-material/Event";
  import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import { TASK_STATUSES } from "../../constants/task";
  
  export const TaskDetailsModal = ({ open, onClose, task }) => {
    const theme = useTheme();
  
    if (!task) return null;
  
    const formatDate = (dateString) => {
      const date = new Date(dateString);
      return format(date, "MMM dd, yyyy hh:mm a");
    };
  
    const getTimeRemaining = (dueDate) => {
      const now = new Date();
      const diff = new Date(dueDate) - now;
  
      if (diff <= 0) {
        return { text: "End", color: "error" };
      }
  
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  
      let text = "";
      if (days > 0) text += `${days}d `;
      if (hours > 0 || days > 0) text += `${hours}h `;
      text += `${minutes}m`;
  
      let color = "success";
  
      return { text, color };
    };
  
    const timeRemaining = getTimeRemaining(task.deadLine);
  
    return (
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ bgcolor: theme.palette.primary.main, color: "white" }}>
          Task Details
        </DialogTitle>
        <DialogContent dividers sx={{ pt: 3 }}>
          <Stack spacing={3}>
            {/* Task ID */}
            <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Box>
              <Typography variant="subtitle2" color="textSecondary">
                REFERENCE NUMBER
              </Typography>
              <Typography variant="h6">{task.taskId}</Typography>
            </Box>
            <Box>
              <Typography variant="subtitle2" color="textSecondary">
                STATUS
              </Typography>
              <Typography
                variant="h6"
                color={"primary"}>
                {TASK_STATUSES.find((s) => s.value === task.status)?.label ||
                  "Unknown"}
              </Typography>
            </Box>
          </Box>
  
            {/* Description */}
            <Box>
              <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                <DescriptionIcon color="primary" />
                <Typography variant="subtitle2" color="textSecondary">
                  DESCRIPTION
                </Typography>
              </Stack>
              <Paper variant="outlined" sx={{ p: 2 }}>
                <Typography>{task.description}</Typography>
              </Paper>
            </Box>
  
            <Divider />
  
            {/* Assigned By/To */}
            <Stack direction="row" spacing={4}>
              <Box flex={1}>
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                  <AssignmentIndIcon color="primary" />
                  <Typography variant="subtitle2" color="textSecondary">
                    ASSIGNED BY
                  </Typography>
                </Stack>
                <Typography>
                  {task.senderAgentName || "Agency"}
                </Typography>
              </Box>
  
              <Box flex={1}>
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                  <PersonIcon color="primary" />
                  <Typography variant="subtitle2" color="textSecondary">
                    ASSIGNED TO
                  </Typography>
                </Stack>
                <Typography>{task.receiverAgentName}</Typography>
              </Box>
            </Stack>
  
            <Divider />
  
            {/* Dates */}
            <Stack direction="row" spacing={4}>
              <Box flex={1}>
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                  <EventIcon color="primary" />
                  <Typography variant="subtitle2" color="textSecondary">
                    ASSIGNED DATE
                  </Typography>
                </Stack>
                <Typography>{formatDate(task.taskReceivedDate)}</Typography>
              </Box>
  
              <Box flex={1}>
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                  <EventIcon color="primary" />
                  <Typography variant="subtitle2" color="textSecondary">
                    DUE DATE
                  </Typography>
                </Stack>
                <Typography>{formatDate(task.deadLine)}</Typography>
              </Box>
            </Stack>
  
            <Divider />
  
            {/* Time Remaining */}
            <Box>
              <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                <AccessTimeIcon color="primary" />
                <Typography variant="subtitle2" color="textSecondary">
                  TIME REMAINING
                </Typography>
              </Stack>
              <Chip
                label={timeRemaining.text}
                color={timeRemaining.color}
                variant="outlined"
                sx={{ fontWeight: "bold" }}
              />
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };